function handleMergeElementTrade() {
    let broElement = document.querySelector('label[for="select-group-42f01cb221bb0"]')?.closest('.bss-b2b-rf-field.field-select');
    const parentDivs = [document.querySelector('label[for="text-field-d97bfcb7e1ab9"]')?.closest('.bss-b2b-rf-field.field-text'), document.querySelector('label[for="text-field-b91b13a24a032"]')?.closest('.bss-b2b-rf-field.field-text'), document.querySelector('label[for="text-field-368c9b81ad15a"]')?.closest('.bss-b2b-rf-field.field-text'), document.querySelector('label[for="text-field-e391c4ae4cf1d"]')?.closest('.bss-b2b-rf-field.field-text'),];
    const container = document.createElement('div');
    container.classList.add('bss-custom-fields');
    container.style.display = "grid";
    container.style.columnGap = "16px"
    container.style.gridTemplateColumns = "1fr 1fr";
    parentDivs.forEach(div => {
      if(div){
        container.appendChild(div);
      }
    });
    if (broElement && broElement.parentNode) {
        broElement.parentNode?.insertBefore(container, broElement.nextSibling);
    }
}

function handleMergeElementInfo() {
    let parentElementInfo = document.querySelector("form#bss-b2b-register-form");
    const parentDivsInfo = [document.querySelector('label[for="first_name"]')?.closest('.bss-b2b-rf-field.field-text'), document.querySelector('label[for="last_name"]')?.closest('.bss-b2b-rf-field.field-text'), document.querySelector('.bss-b2b-rf-field.field-email'), document.querySelector('.bss-b2b-rf-field.field-password')];
    const containerInfo = document.createElement('div');
    containerInfo.classList.add('bss-custom-fields');
    containerInfo.style.display = "grid";
    containerInfo.style.columnGap = "16px";
    containerInfo.style.gridTemplateColumns = "1fr 1fr";
    parentDivsInfo.forEach(div => {
      if(div){
        containerInfo.appendChild(div);
      }
        
    });
  if (parentElementInfo) {
        parentElementInfo?.insertBefore(containerInfo, parentElementInfo.firstChild);
    }
}

function handleMergeElementZip() {
    let parentElementZip = document.querySelector('label[for="company-field"]')?.closest('.bss-b2b-rf-field.field-text')
    const parentDivsZip = [document.querySelector('label[for="city-field"]')?.closest('.bss-b2b-rf-field.field-text'), document.querySelector('label[for="zip-field"]').closest('.bss-b2b-rf-field.field-text')];
    const containerZip = document.createElement('div');
    containerZip.classList.add('bss-custom-fields');
    containerZip.style.display = "grid";
    containerZip.style.columnGap = "16px";
    containerZip.style.gridTemplateColumns = "1fr 1fr";
    parentDivsZip.forEach(div => {
      if(div){
         containerZip.appendChild(div);
      }
    });
  if (parentDivsZip) {
        parentElementZip?.insertBefore(containerZip, parentDivsZip.firstChild);
    }
}

let counter = 0;
let selector = "#bss-b2b-registration-form"
const interval = setInterval(() => {
    if ($(selector).length > 0) {
        handleMergeElementTrade();
        handleMergeElementInfo()
        handleMergeElementZip()
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100);